import { render, staticRenderFns } from "./layer-transfer-deposit-bill.vue?vue&type=template&id=63c6c994&scoped=true&"
import script from "./layer-transfer-deposit-bill.vue?vue&type=script&lang=js&"
export * from "./layer-transfer-deposit-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6c994",
  null
  
)

export default component.exports